import React from 'react';
import BoxMetrics from '../BoxMetrics';
import { useGetTableQuery } from '../../redux/api/whitelistedMediaComparison';
import TableContainer from '../TableContainer';
import { useSelector, useDispatch } from 'react-redux';
import { setWhitelistedMediaGranularityLevel } from '../../redux/store/genericReportingSlice';

const WhitelistedMediaCharts = (
    {
        platform
    }
) => {

    const selectedStartDate = useSelector((state) => state.genericReporting.selectedDropdownValues['start_date']);
    const selectedEndDate = useSelector((state) => state.genericReporting.selectedDropdownValues['end_date']);
    const selectedClient = useSelector((state) => state.genericReporting.selectedDropdownValues['client_name']);
    const selectedGranularityLevel = useSelector((state) => state.genericReporting.whitelistedMediaGranularityLevel);

    return (
        <div style={{
            'width': '90vw'
        }}>
            <div style={{
                'witdh': '90vw'
            }}>
                <BoxMetrics isAmazon={false} isInfluencer={false} isOutreach={false} useOldPrefix={false} suffixStr={
                    `whitelisted_media_comparison/${platform}`
                }></BoxMetrics>
                <div>
                </div>
                <TableContainer
                    useApi={useGetTableQuery}
                    apiParams={
                        {
                            client: selectedClient,
                            startDate: selectedStartDate,
                            endDate: selectedEndDate,
                            platform: platform,
                            groupBy: selectedGranularityLevel
                        }
                    }></TableContainer>
            </div>
        </div>
    );
};

export default WhitelistedMediaCharts;